import MuiTableRow from '@material-ui/core/TableRow';
import MuiTableCell from '@material-ui/core/TableCell';
import { Flex } from '../../layout-components';
import Icon from '../../Icon';
import { Inline } from '../../Text';

const LoadMoreRow = ({ row }) => {
  const { childrenInView, totalChildren, onClick } = row;

  if (!childrenInView || !totalChildren || !onClick) return null;

  return (
    <MuiTableRow onClick={() => onClick(row)}>
      <MuiTableCell colSpan={100}>
        <Flex justify='center'>
          <Inline style={{ fontSize: '1.2rem', fontWeight: '400' }}>
            Viewing {childrenInView} of {totalChildren}
          </Inline>

          <Flex pl='small' cursor='pointer'>
            <Icon name='LoadMore' size='smaller' color='chambray' />
            <Inline
              pl='0.5rem'
              color='chambray'
              style={{ fontSize: '1.2rem', fontWeight: '400' }}
            >
              {' '}
              Load more
            </Inline>
          </Flex>
        </Flex>
      </MuiTableCell>
    </MuiTableRow>
  );
};

export default LoadMoreRow;
